/** @format */

export default {
  setMedicalLettersRequests(state, payload) {
    state.medicalLetterRequests = payload;
  },
  setMedicalLetterRequest(state, payload) {
    state.medicalLetterRequest = payload;
  },
  setMedicalLetterRequestQuestions(state, payload) {
    state.medicalLetterRequestQuestions = payload.data;
  },
  setSignature(state, payload) {
    state.signature = payload;
  },
  updateSignature(state, payload) {
    state.signature = [payload, ...state.signature];
  },
  editSignature(state, payload) {
    state.signature.splice(payload.signatureId, 1, payload.response);
  },

  setSignatureDoctor(state, payload) {
    state.signatureDoctor = payload;
  },
  updateSignatureDoctor(state, payload) {
    state.signatureDoctor = payload;
  },
  editSignatureDoctor(state, payload) {
    state.signatureDoctor.doctor_signature = payload;
  },

  deleteSignatureDoctor(state) {
    state.signatureDoctor = {};
  },
  setDoctorsProfile(state, payload) {
    state.doctorsProfile = payload;
  },
  setDoctorProfile(state, payload) {
    state.doctorProfile = payload;
  },

  setDoctor(state, payload) {
    state.doctor = payload;
  },

  setEmailError(state, payload) {
    state.emailError = payload;
  },
  setPractices(state, payload) {
    state.practices = payload;
  },
};
